<template>
  <div class="footer">
    <!--Loading-->
    <!-- <div class="loading" v-if="loading">
      請稍候，正在幫您尋找解決辦法中。<i class="el-icon-loading"></i>
    </div> -->

    <div
      class="backTop"
      tabindex="0"
      @keyup.enter="scrollToTop"
      @click="scrollToTop"
      v-if="showBackTop"
      aria-label="Back to top button"
    >
      <img src="@/assets/images/icons/backTop.svg" alt="Back Top button" />
    </div>

    <div v-if="botStart && !isFinished" class="contenteditable">
      <div
        contenteditable
        id="content-box"
        class="content-box"
        v-on:keydown.13="beforeSubmit"
        aria-label="question editor"
        :data-placeholder="
          loading ? $t('GPT.LAYOUT.WAIT') : $t('GPT.LAYOUT.INPUT')
        "
      ></div>
      <!-- {{ inputTime }}s -->
      <div
        class="text-limit"
        :class="{ danger: length > maxLength, isAllowSpeech }"
      >
        <span>{{ length }}</span
        >/{{ maxLength }}
      </div>

      <div class="actions">
        <div
          tabindex="0"
          class="action submit"
          :class="{ disabled: loading || length > maxLength }"
          @click="beforeSubmit"
          @keyup.enter="beforeSubmit"
          aria-label="Send button"
        ></div>
        <div
          tabindex="0"
          v-if="isAllowSpeech"
          class="action mic-button"
          :class="{
            listening: speeking,
            disabled: loading || length > maxLength,
          }"
          @click="toggleSpeech"
          @keyup.enter="toggleSpeech"
          aria-label="Mic button"
        ></div>
      </div>
    </div>

    <div class="speeking" v-if="speeking">
      <p :class="[speeking ? 'listening' : '']">
        {{ $t("GPT.LAYOUT.RECORDING") }}
      </p>
    </div>

    <div class="end" v-show="isFinished">
      <el-button type="primary" @click="handleEnd">
        {{ isSurvey ? $t("GPT.END_SURVEY") : $t("GPT.END") }}
      </el-button>
    </div>
  </div>
</template>

<script>
import { languageMap } from "@/plugins/languages";
import DOMPurify from "dompurify";
export default {
  name: "gpt-footer",
  data() {
    return {
      recognition: null,
      isAllowSpeech: false, // 是否允許語音辨識
      speeking: false, // 是否正在說話
      contenteditable: null,
      inputTime: 0,
      inputTimer: null,
      triggerTime: 2, //觸發GPT間隔 2 秒
      showBackTop: false,
      maxLength: 200, // 輸入限制
      length: 0,
    };
  },
  watch: {
    inputTime(val) {
      if (val >= this.triggerTime) {
        this.initTimer(false);
        this.$store.dispatch("gpt/createChatRenderMessage");
      }
    },
    $route() {
      // route change = new room
      this.$store.commit("gpt/saveUserInput");
    },
    botStart(val) {
      if (val) {
        this.$nextTick(function () {
          this.initEditor();
        });
      }
    },
    isFinished(val) {
      if (val) {
        if (this.isSurvey) {
          window.dataLayer.push({
            event: "data_layer_event",
            chatbot_session_id: this.chatbot_session_id,
            event_name_ga4: "survey_impression_genio",
            event_category_DL: "genio",
            event_action_DL: "displayed",
            event_label_DL: "survey_impression",
          });
        } else {
          window.dataLayer.push({
            event: "data_layer_event",
            chatbot_session_id: this.chatbot_session_id,
            event_name_ga4: "close_chat2_impression_genio",
            event_category_DL: "genio",
            event_action_DL: "displayed",
            event_label_DL: "close_chat2_impression",
          });
        }
      }
    },
  },
  mounted() {
    if (this.isFinished !== true && this.botStart) {
      this.initEditor();
    }
    const vm = this;
    document.querySelector(".bot-room").addEventListener("scroll", (e) => {
      vm.handleScroll(e);
    });

    const SpeechRecognition =
      window.SpeechRecognition || window.webkitSpeechRecognition;

    if (!SpeechRecognition || this.isIOSSafari()) {
      console.error(this.$t("GPT.LAYOUT.RECORDING_NOT_SUPPORTED"));
      this.isAllowSpeech = false;
    } else {
      this.isAllowSpeech = true;
    }
  },
  methods: {
    initEditor() {
      const editor = document.querySelector("#content-box");

      editor.addEventListener("keydown", (event) => {
        const { code, keyCode } = event;
        let textLength = this.contenteditable.innerText.trim().length;
        if (
          [
            "Delete",
            "Backspace",
            "ArrowUp",
            "ArrowDown",
            "ArrowLeft",
            "ArrowRight",
          ].includes(code)
        ) {
          return true;
        } else if (keyCode === 13) {
          this.beforeSubmit(event);
        } else {
          if (textLength >= this.maxLength) {
            event.preventDefault();
            return false;
          } else {
            return true;
          }
        }
      });

      editor.addEventListener("input", () => {
        let textLength = editor.innerText.trim().length;
        this.length = textLength;
      });

      editor.addEventListener("paste", (e) => {
        e.preventDefault();
        var text = (e.originalEvent || e).clipboardData.getData("text/plain");
        // insert text manually
        document.execCommand(
          "insertText",
          false,
          text.slice(0, this.maxLength)
        );
      });

      this.contenteditable = editor;
      // GA4 顯示 input 時
      window.dataLayer.push({
        event: "data_layer_event",
        chatbot_session_id: this.chatbot_session_id,
        event_name_ga4: "input_impression_genio",
        event_category_DL: "genio",
        event_action_DL: "displayed",
        event_label_DL: "input_impression/genio",
      });
    },
    beforeSubmit(e) {
      if (!this.contenteditable) {
        this.initEditor();
      }
      let innerHTML = this.contenteditable.innerHTML;
      let textLength = this.contenteditable.innerText.trim().length;
      const pureText = DOMPurify.sanitize(innerHTML, { ALLOWED_TAGS: [] }); // 移除所有標籤
      let data = { type: "Text", content: pureText, chatUserRole: "customer" }; // (System, Text, Image, CustomerStatus)
      // console.log("data", data);
      if (textLength) {
        if (textLength > this.maxLength) {
          e.preventDefault();
          return;
        } else if (e.shiftKey) {
          // enter + shift
          return;
        } else {
          // enter only
          e.preventDefault();
          this.submit(data);
          this.length = 0;
          // console.log("data", data);
        }
      }
    },
    submit(data) {
      if (this.loading) return;
      this.initTimer();
      this.$store.commit("gpt/saveUserInput", data.content);
      this.$store.dispatch("gpt/createMessage", data);
      this.contenteditable.innerHTML = "";
      this.contenteditable.focus();

      // GA4 送出訊息時
      window.dataLayer.push({
        event: "data_layer_event",
        chatbot_session_id: this.chatbot_session_id,
        event_name_ga4: "submit_message_genio",
        event_category_DL: "genio",
        event_action_DL: "clicked",
        event_label_DL: "submit_message/genio",
      });
    },
    initTimer(val = true) {
      // 開始計時文字輸入間隔
      if (val === true) {
        if (this.inputTimer) {
          this.inputTime = 0;
          clearInterval(this.inputTimer);
        }
        this.inputTimer = setInterval(() => {
          this.inputTime++;
        }, 1000);
      } else {
        clearInterval(this.inputTimer);
        this.inputTime = 0;
      }
    },
    handleEnd() {
      if (this.isSurvey) {
        window.dataLayer.push({
          event: "data_layer_event",
          chatbot_session_id: this.chatbot_session_id,
          event_name_ga4: "click_survey_genio",
          event_category_DL: "genio",
          event_action_DL: "clicked",
          event_label_DL: "click_survey/genio",
        });
        this.$router.push("/survey");
      } else {
        // 不進入滿意度調查
        this.$router.push("/end");
      }
    },
    handleScroll(e) {
      const scrollTop = e.target.scrollTop;
      this.showBackTop = scrollTop >= 500 ? true : false;
    },
    scrollToTop() {
      document.querySelector(".bot-room").scrollTop = 0;
    },
    // speech
    isIOSSafari() {
      const ua = window.navigator.userAgent;
      const isIOS = /iP(hone|od|ad)/.test(ua);
      const isSafari = /Safari/.test(ua) && !/CriOS|FxiOS|EdgiOS/.test(ua); // 排除 iOS Chrome/Firefox/Edge
      return isIOS && isSafari;
    },
    toggleSpeech() {
      if (this.speeking) {
        this.stopSpeech();
      } else {
        this.startSpeech();
      }
    },
    startSpeech() {
      const SpeechRecognition =
        window.SpeechRecognition || window.webkitSpeechRecognition;
      if (!SpeechRecognition) {
        alert(this.$t("GPT.LAYOUT.RECORDING_NOT_SUPPORTED"));
        return;
      }

      const vm = this;
      const recognition = new SpeechRecognition();
      recognition.lang = languageMap[vm.countryId] || "en-US"; // 預設英文
      recognition.continuous = true;
      recognition.interimResults = true;

      vm.recognition = recognition;

      recognition.onresult = (event) => {
        let finalText = "";
        let interimText = "";

        for (let i = event.resultIndex; i < event.results.length; i++) {
          const res = event.results[i];
          const txt = res[0].transcript;
          res.isFinal ? (finalText += txt) : (interimText += txt);
        }

        const el = document.getElementById("content-box");

        if (finalText) {
          vm.clearInterimText(el);
          vm.insertTextAtCursor(el, finalText);
        }

        if (interimText) {
          vm.showInterimText(el, interimText);
        }
      };

      recognition.onstart = () => {
        vm.speeking = true;
      };

      recognition.onend = () => {
        vm.speeking = false;
        const el = document.getElementById("content-box");
        vm.clearInterimText(el);
      };

      recognition.onerror = (e) => {
        console.error("Recognition error: " + e.error);
        alert(this.$t("GPT.LAYOUT.RECORDING_NOT_FOUND"));
      };

      recognition.start();
      vm.speeking = true;
    },
    stopSpeech() {
      if (this.recognition && this.speeking) {
        this.recognition.stop();
        this.speeking = false;
      }
    },
    showInterimText(el, text) {
      let interimEl = el.querySelector(".interim-span");
      if (!interimEl) {
        interimEl = document.createElement("span");
        interimEl.className = "interim-span";
        el.appendChild(interimEl);
      }
      interimEl.textContent = text;
    },
    clearInterimText(el) {
      const interimEl = el.querySelector(".interim-span");
      if (interimEl) el.removeChild(interimEl);
    },
    insertTextAtCursor(el, text) {
      el.focus();
      const selection = window.getSelection();
      if (!selection || selection.rangeCount === 0) {
        el.innerText += text;
        return;
      }

      const range = selection.getRangeAt(0);
      range.deleteContents();
      range.insertNode(document.createTextNode(text));
      range.collapse(false);
      selection.removeAllRanges();
      selection.addRange(range);
    },
  },
  computed: {
    countryId() {
      return this.$store.state.gpt.botRoom.countryId;
    },
    loading() {
      return this.$store.state.gpt.loading;
    },
    userInputs() {
      return this.$store.state.gpt.userInputs;
    },
    isFinished() {
      return this.$store.state.gpt.botRoom.isFinished;
    },
    botStart() {
      return this.$store.getters["gpt/botStart"];
    },
    chatbot_session_id() {
      return this.$store.getters["gpt/chatbot_session_id"];
    },
    isSurvey() {
      return this.$store.state.gpt.setting?.ChatGPT_IsShow_Survey === "1"
        ? true
        : false;
    },
  },
};
</script>

<style lang="scss" scoped>
.footer {
  position: sticky;
  bottom: 0;
  box-shadow: 4px 1px 12px 0px #0000001a;
  .contenteditable {
    background-color: #fff;
    width: 100%;
    display: flex;
    align-items: center;
    position: relative;
    padding: 16px;
    z-index: 10;
    .content-box {
      flex: 1;
      min-height: 40px;
      border: 1px solid #818181;
      padding: 10px;
      background: #fff;
      margin-right: 6px;
      border-radius: 8px;
      max-height: 150px;
      overflow: auto;
      outline: none;
      font-size: 100%;
      line-height: 18px;
    }
    [contenteditable="true"]:empty:not(:focus):before {
      pointer-events: none;
      content: attr(data-placeholder);
      color: #666;
      font-size: 14px;
      line-height: 18px;
    }
    .actions {
      display: flex;
      align-items: center;
      gap: 5px;
      .action {
        cursor: pointer;
        width: 32px;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        -webkit-user-drag: none;
        -webkit-touch-callout: none;
        user-select: none;
      }
      .submit {
        background-image: url("../../assets/images/icons/submit.svg");
        background-size: 80%;
        background-repeat: no-repeat;
        background-position: center center;
      }
      .mic-button {
        background-image: url("../../assets/images/icons/microphone.png");
        background-size: 80%;
        background-repeat: no-repeat;
        background-position: center center;
      }

      .mic-button.listening {
        background-image: url("../../assets/images/icons/microphone_white.png");
        background-color: #ff4d4f;
        animation: pulse 1.2s infinite;
        color: white;
      }
    }
    .text-limit {
      user-select: none;
      right: 65px;
      bottom: 20px;
      position: absolute;
      font-size: 12px;
      color: #aaa;
    }
    .text-limit.isAllowSpeech {
      right: 100px;
    }
    .danger {
      span {
        color: red;
      }
    }
    .submit {
      cursor: pointer;
      width: 24px;
      height: 24px;
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }

    .disabled {
      cursor: not-allowed;
      opacity: 0.5;
    }
  }
  .backTop {
    cursor: pointer;

    position: absolute;
    top: -52px;
    right: 20px;
    width: 32px;
    height: 32px;
    img {
      width: 100%;
      height: 100%;
    }
    &:hover {
      opacity: 1;
    }
  }
  .speeking {
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 9;
    top: 50%;
    left: 50%;
    border-radius: 8px;
    transform: translate(-50%, -50%);
    background-color: rgba(black, 0.1);
    padding: 15px;
    text-align: center;
    font-size: 14px;
    display: flex;
    justify-content: center;
    align-items: center;
    p {
      border-radius: 8px;
      padding: 10px;
      width: 200px;
      background-color: white;
      color: $primary;
    }
    p.listening {
      animation: pulse2 1.2s infinite;
    }
  }
}

// .loading {
//   z-index: -1;
//   font-size: 14px;
//   position: absolute;
//   bottom: 70px;
//   left: 0;
//   width: 100%;
//   overflow: hidden;
//   display: flex;
//   margin: 0;
//   padding: 10px 15px;
//   background: linear-gradient(#ffffff00 0%, #ffffff85 30%, #ffffff 100%);
//   display: flex;
//   align-items: center;
// }
.end {
  width: 100%;
  background-color: #fff;
  position: sticky;
  bottom: 0;
  padding: 8px;
  .el-button {
    width: 100%;
  }
}

@media (max-width: 1024px) {
  .gpt-footer {
    position: fixed;
    left: 0;
  }
}
</style>
